export enum MoveCategory {
    Missed = 'Missed Chance',
    InvalidMove = 'Illegal Move',
    JokerMove = 'Jokers have no suit',
    ValidMove = 'Valid'
}
